import authApi from '@/api/authApi';
import usersApi from '@/api/usersApi';
import { normalizeError } from '@/errors/normalize';

/**
 * Authentication service for handling both EDS and Admin login flows
 */
export const authService = {
  /**
   * Admin login using email and password
   */
  adminLogin: async ({ email, password }) => {
    try {
      const response = await authApi.login({ email, password });
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      const normalized = normalizeError(error);
      throw {
        success: false,
        error: normalized,
      };
    }
  },

  /**
   * Get user details using token
   */
  getUserDetails: async token => {
    try {
      const response = await usersApi.getUserDetails(token);
      return response.data;
    } catch (error) {
      const normalized = normalizeError(error);
      throw normalized;
    }
  },

  /**
   * EDS authentication - get backend GUID for signing
   */
  getEDSGuid: async () => {
    try {
      const response = await usersApi.getEDSGuid();
      return response.data;
    } catch (error) {
      const normalized = normalizeError(error);
      throw normalized;
    }
  },

  /**
   * Verify EDS signature and complete authentication
   */
  verifyEDSSignature: async ({ pkcs, infoCert }) => {
    try {
      const response = await usersApi.verifyEDSSignature({ pkcs, infoCert });
      return response.data;
    } catch (error) {
      const normalized = normalizeError(error);
      throw normalized;
    }
  },

  /**
   * Refresh authentication token
   */
  refreshToken: async refreshToken => {
    try {
      const response = await authApi.refreshToken(refreshToken);
      return response;
    } catch (error) {
      const normalized = normalizeError(error);
      throw normalized;
    }
  },

  /**
   * Logout user
   */
  logout: async token => {
    try {
      await authApi.logout(token);
      return { success: true };
    } catch {
      // Even if logout fails on server, we consider it successful locally
      return { success: true };
    }
  },
};
